import { styled } from '@mui/material/styles';
import { COLORS } from '../../../../../common/Styleguide/Common/colors';

export const CardContainer = styled('div')({
  fontFamily: 'Nunito',
  lineHeight: '135%',
  width: 280,
  height: 340,
  backgroundColor: COLORS.black[80],
  borderRadius: '10px',
  overflow: 'hidden',
});

interface CardImageProps {
  url: string;
}
export const CardImage = styled('div', { shouldForwardProp: (prop) => prop !== 'url' })<CardImageProps>(({ url }) => ({
  backgroundImage: `url(${url})`,
  backgroundSize: 'cover',
  width: '100%',
  height: 150,
  backgroundColor: COLORS.black[70],
}));

export const CardTexts = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2.5),
  gap: theme.spacing(0.5),
}));

export const CardDate = styled('div')(() => ({
  fontWeight: 700,
  fontSize: '12px',
  color: COLORS.white[30],
}));

export const CardTitle = styled('div')({
  fontWeight: 700,
  fontSize: '16px',
  color: COLORS.white[80],

  /** props for 2 line text wrap with ellipsis */
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  overflow: 'hidden',
});

export const CardIntro = styled('div')({
  fontWeight: 400,
  fontSize: '14px',
  color: COLORS.white[60],

  /** props for 4 line text wrap with ellipsis */
  WebkitLineClamp: '4',
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  overflow: 'hidden',
});
